import React from 'react';
import { RawTrader, TraderCardData } from './types';
import { ExpertTraderCard } from './ExpertTraderCard';

interface ExpertTraderSectionProps {
  title: string;
  description: string;
  buttonLabel: string;
  traders: { t: RawTrader; card: TraderCardData }[];
  onSelectTrader: (rawIndex: number) => void;
  onViewAll?: () => void;
}

export const ExpertTraderSection: React.FC<ExpertTraderSectionProps> = ({
  title,
  description,
  buttonLabel,
  traders,
  onSelectTrader,
  onViewAll,
}) => {
  if (traders.length === 0) return null;

  return (
    <div className="mb-10">
      {/* Section Header */}
      <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-5 gap-4">
        <div>
          <h2 className="text-2xl font-bold flex items-center text-gray-900">{title}</h2>
          <p className="text-gray-500 text-sm mt-1">{description}</p>
        </div>
        {onViewAll && (
          <div className="flex items-center space-x-3">
            <button
              onClick={onViewAll}
              className="px-5 py-2 !rounded-full border border-gray-300 bg-white text-sm font-medium hover:bg-gray-100 transition-colors text-gray-800 shadow-sm cursor-pointer"
            >
              {buttonLabel}
            </button>
          </div>
        )}
      </div>

      {/* Grid of Strategy Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {traders.map(({ t, card }) => (
          <ExpertTraderCard
            key={t.name}
            trader={t}
            card={card}
            onSelect={() => onSelectTrader(card.rawIndex)}
          />
        ))}
      </div>
    </div>
  );
};
